// extracted by mini-css-extract-plugin
export default {"wrapper":"Description_wrapper__BF6zh","description":"Description_description__q91r-","seeMore":"Description_seeMore__Jo8qM"};